/* eslint-disable react/function-component-definition */

import React, { useContext, useEffect } from 'react';
import styles from './index.module.scss';
import { TableContext } from '../../contexts/tableContext';
import ShowCard from '../../components/ShowCard/ShowCard';

const ShowsIndex = React.memo(() => {
  const { dashboardStyle, bodyStyle, setDashboardHeader } = useContext(TableContext);
  useEffect(() => {
    setDashboardHeader('');
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className={styles[bodyStyle]}>
      <div className={styles[dashboardStyle]} id={styles.dashboardcont2}>
        <ShowCard />
      </div>
    </div>
  );
});
export default ShowsIndex;
